export default {
  APP_NAME: 'RS Tasktracker',
  STORAGE_NAME: 'userData',
  FULLNAME_REGEXP: /^[\w!#$%&'*+/=?^_`{|}~\- №"@]+$/,
  EMAIL_REGEXP: /^[\w!#$%&'*+/=?^_`{|}~]*(?:\.?[\w!#$%&'*+/=?^_`{|}~-]+)@[^.@]+\.[^.@]{2,}$/,
  PASSWORD_REGEXP: /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z]{6,}$/,
  LABELS_COLORS: [
    { color: '#ef5350', textColor: '#fff' },
    { color: '#9c27b0', textColor: '#fff' },
    { color: '#2196f3', textColor: '#fff' },
    { color: '#3f51b5', textColor: '#fff' },
    { color: '#ff5722', textColor: '#fff' },
    { color: '#009688', textColor: '#fff' },
    { color: '#00bcd4', textColor: '#000' },
    { color: '#8bc34a', textColor: '#000' },
    { color: '#cddc39', textColor: '#000' },
    { color: '#4caf50', textColor: '#000' },
    { color: '#ffeb3b', textColor: '#000' },
    { color: '#ffc107', textColor: '#000' },
    { color: '#ff9800', textColor: '#000' },
  ],
  BACKGROUND_COLORS: ['#f44336', '#e91e63', '#9c27b0', '#ba68c8', '#ff5252', '#ea80fc', '#673ab7', '#3f51b5', '#2196f3', '#0d47a1', '#00bcd4', '#009688', '#1de9b6', '#00c853', '#69f0ae', '#00e676', '#ff9800', '#ffc107', '#ffee58', '#ff7043', '#8d6e63', '#757575', '#607d8b', '#424242'],
};
